import { Outlet } from "react-router-dom"

const EmptyLayout = () => <Outlet />

export default EmptyLayout
